module.exports = __webpack_public_path__ + "img/chart.9530dbbf.svg";